import React, { useContext, useState } from 'react';

import SelectInput from '../../components/SelectInput/SelectInput';

import useAuthAdmin from '../hooks/useAuthAdmin';
import useFetchAllDraws from '../hooks/useFetchAllDraws';
import useFetchResults from '../hooks/useFetchResults';
import useSetPageTitle from '../../hooks/useSetPageTitle';

import ResultsTable from '../components/ResultsTable/ResultsTable';
import PopupAddress from '../components/PopupAddress/PopupAddress';

import tryExportingWinners from '../exports/winners';

import LinearLoader from "../../components/Loader/LinearLoader";

import AdminContext from "../contexts/AdminContext";

import './styles.css';

function AcompanharAdmin() {

    useAuthAdmin();
    useSetPageTitle('Admin');

    const { currentPromo } = useContext(AdminContext);

    const { drawsOption } = useFetchAllDraws(currentPromo?.id);
    const [draw, setDraw] = useState('');

    const [popupAddress, setPopupAddress] = useState(false);
    const [address, setAddress] = useState({});

    const [loadingExport, setLoadingExport] = useState(false);
    const [errorExport, setErrorExport] = useState('');

    const results = useFetchResults(currentPromo?.id, draw);

    return (
        <>
            { popupAddress ? <PopupAddress setPopup={setPopupAddress} address={address} /> : false }
            <div className="admin-page-container">
                <div className="admin-page-title-container">
                    <p className="admin-page-title">Acompanhar resultados</p>
                    <p className="admin-page-error-import">{errorExport}</p>
                </div>
                <div className="admin-page-select-input-container">
                    <SelectInput
                        options={drawsOption.map(el => ({ label: `Sorteio ${el.tipo.charAt(0).toUpperCase() + el.tipo.slice(1)} - ${el.data.replaceAll('-', '/')}`, value: el.id }))}
                        value={drawsOption.filter(option => option.value === draw)[0]}
                        setOption={(value) => {
                            setDraw(value.value);
                        }}
                        rubik
                    />
                    { loadingExport ? <LinearLoader /> : false }
                    {
                        results.length ?
                        <div className="admin-page-export-container-table">
                            <button className="admin-page-download-button" onClick={() => tryExportingWinners(currentPromo.id, draw, setLoadingExport, setErrorExport)}>Baixar premiados</button>
                        </div>
                        : false
                    }
                </div>
                <div style={{ marginBottom: '32px' }} />
                <ResultsTable results={results} setPopup={setPopupAddress} setAddress={setAddress} />
            </div>
        </>
    )
}

export default AcompanharAdmin;